/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ChangeLogDescription } from './changeLogDescription';
import { UsersChanges } from './usersChanges';


export interface CreateTeamChangeLogDto { 
    actionPerformed: string;
    teamId: string;
    description?: ChangeLogDescription;
    usersChanges?: UsersChanges;
    projectId?: object;
    createdBy?: string;
}

